import { render, staticRenderFns } from "./ClientVar.vue?vue&type=template&id=5663e6a4&scoped=true"
import script from "./ClientVar.vue?vue&type=script&lang=js"
export * from "./ClientVar.vue?vue&type=script&lang=js"
import style0 from "./ClientVar.vue?vue&type=style&index=0&id=5663e6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663e6a4",
  null
  
)

export default component.exports